import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InspectionCapacityCase } from '@authority-labs/api-interfaces';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-capacity-case',
  templateUrl: './check-capacity-case.component.html',
  styleUrls: ['./check-capacity-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckCapacityCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: InspectionCapacityCase;
}
